import { motion, AnimatePresence } from "framer-motion";
import { useShows } from "@/context/shows";
import { useBuy } from "@/context/buy";
import Container from "../Common/Container";
import { Skeleton } from "@mui/material";
import useEmblaCarousel from "embla-carousel-react";
import { useEffect, useCallback } from "react";

export default function ShowsFilter() {
  const { states, intialLoading, loading } = useShows();
  const { selectedState, setSelectedState } = useBuy();
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    containScroll: "trimSnaps",
  });

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
        delayChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3
      }
    }
  };

  return (
    <Container className="pt-5 relative pb-2 lg:pt-3 w-full overflow-hidden gradient-skeleton px-6 lg:my-5 lg:pl-[75px]">
      {intialLoading ? (
        <div className="relative w-full overflow-hidden">
          <div className="embla " ref={emblaRef}>
            <div className="embla__container flex gap-4">
              {[...Array(10)].map((_, i) => (
                <div key={i} className="embla__slide min-w-[170px]">
                  <Skeleton
                    variant="rectangular"
                    width={170}
                    height={80}
                    className="rounded-lg"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : states.length === 0 ? (
        <p className="text-white text-center py-5">No States Available</p>
      ) : (
        <motion.div
          className="embla overflow-hidden relative"
          ref={emblaRef}
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <div className="embla__container flex gap-4">
            <AnimatePresence mode="wait">
              {states.map((state, i) => (
                <motion.div
                  key={`${state.id}_${i}`}
                  variants={itemVariants}
                  layout
                  className="embla__slide min-w-fit pr-2 lg:pr-[16px]"
                >
                  <motion.div
                    onClick={() => {
                      if (!loading) { 
                        setSelectedState(state)
                      }
                    }}
                    className={`flex py-[7px] px-4 gradient-border w-full ${state.code === selectedState?.code ? "active-state" : ""
                      } lg:py-[12px] lg:px-[26px] max-w-fit cursor-pointer bg-[#08080A] rounded-[8px] lg:rounded-[16px] items-center justify-start gap-3`}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="hidden lg:block">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.25 12C2.25 18.937 4.563 21.25 11.5 21.25C18.437 21.25 20.75 18.937 20.75 12C20.75 5.063 18.437 2.75 11.5 2.75C4.563 2.75 2.25 5.063 2.25 12Z"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.19824 15.3022L9.77224 10.2722L14.8022 8.69824L13.2282 13.7272L8.19824 15.3022Z"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <motion.p
                      className="lg:py-2 font-bold lg:text-xl lg:leading-[40px] lg:pr-[5px] lg:rounded-[16px]"
                      layout
                    >
                      {state.name}
                    </motion.p>
                  </motion.div>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
          <NextArrow onClick={scrollNext} />
        </motion.div>
      )}
    </Container>
  );
}

const NextArrow = ({ onClick }) => (
  <div
    className="absolute right-0 top-0 h-full flex items-center justify-end z-10 pr-4 cursor-pointer"
    onClick={onClick}
  >
    <div className="hidden lg:block">
      <div className="slider_custom_next_arrow">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.42467 17.225C7.26634 17.225 7.10801 17.1667 6.98301 17.0417C6.74134 16.8 6.74134 16.4 6.98301 16.1583L12.4163 10.725C12.8163 10.325 12.8163 9.67502 12.4163 9.27502L6.98301 3.84168C6.74134 3.60002 6.74134 3.20002 6.98301 2.95835C7.22467 2.71668 7.62467 2.71668 7.86634 2.95835L13.2997 8.39168C13.7247 8.81668 13.9663 9.39168 13.9663 10C13.9663 10.6083 13.733 11.1833 13.2997 11.6083L7.86634 17.0417C7.74134 17.1583 7.58301 17.225 7.42467 17.225Z"
            fill="#F9F9F9"
          />
        </svg>
      </div>
    </div>
  </div>
);
